<template>
  <div>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <v-dialog v-model="locationDialog">
      <v-card class="pa-1">
        <v-card-title>
          Verify Your Location
        </v-card-title>
        <v-card-text>
          <div style="padding-bottom:5px; color:gray; font-size: 12px;">
            Current Location:
          </div>
          <div v-if="hasLocationError == false">
            {{ address }}
          </div>

          <div v-if="hasLocationError" style="color:red;">
            {{ location }}
          </div>
          <!-- <img :src="googleMapSrc" width="100%" v-if="latlon != null" /> -->
        </v-card-text>
        <v-card-actions>
          <v-btn small color="secondary" round ripple @click="confirmLocation"
            :disabled="hasLocationError || (location == null || location == '')">Confirm
            Location</v-btn>
          <v-btn small color="secondary" round ripple @click="GetLocation">Try Again</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog.show" width="500">
      <v-card class="pa-1">
        <v-card-title>
          Confirm
        </v-card-title>
        <v-flex xs12>
          <v-form>
            <v-layout row align-center>
              <v-subheader>
                Are you sure you want to start the customer visit?
              </v-subheader>
              <v-spacer></v-spacer>
            </v-layout>
            <v-layout justify-end>
              <v-btn small color="primary" @click="showLocationDialog">Confirm</v-btn>
              <v-btn small color="secondary" @click="cancelLConfirm">Cancel</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-card>
    </v-dialog>

    <v-dialog v-model="adhocDialog" width="500">
      <v-card class="pa-1">
        <v-card-title>
          Ad-Hoc Visit
        </v-card-title>
        <v-flex xs12>
          <v-form>
            <v-combobox label="Select customer" v-model="AllocationForm.CustomerID" :items="customerItems"
              item-text="Name" item-value="ID" @change="GetCustomerVenues"></v-combobox>
            <v-combobox label="Select venue" v-model="AllocationForm.CustomerVenueID" :items="venueItems"
              item-text="Name" item-value="ID" :disabled="venueItems.length == 0">
            </v-combobox>
            <v-layout justify-end>
              <v-btn small color="primary" @click="startAdhocVisit">Confirm</v-btn>
              <v-btn small color="secondary" @click="cancelAdHocVisit">Cancel</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-card>
    </v-dialog>

    <v-date-picker v-model="date" :picker-date.sync="pickerDate" full-width :event-color="getColor"
      :events="events"></v-date-picker>

    <div class="px-2">
      <v-btn color="primary" block small @click="showAdhocDialog">Ad-Hoc Visit</v-btn>
    </div>

    <div v-if="dayEvents == null || dayEvents.length == 0"
      style="display: flex; justify-content: center; align-content: center; height: calc(100vh - 580px);">
      <div>No events found for the selected day</div>
    </div>

    <div v-for="item in dayEvents" @click="() => viewTask(item)" style="position:relative;">
      <div v-if="item.Complete"
        style="position: absolute; top: 0; left:0; background: rgb(128 128 128 / 75%); width:100%; height: 100%; display: flex; justify-content: end; align-items: center; padding-right:5px;">
        <span style="font-weight: bold; color:green;">Complete</span>
      </div>
      <div style="padding: 8px; display: flex; align-items: center; border-top: 1px solid lightgray;">
        <div style="width:12px; height:12px; background:red; border-radius:50%; margin-right: 5px;"></div>
        <div style="font-size: 14px; font-weight: 600;">
          {{ item.Customer.Name }} - {{ item.CustomerVenue.Name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JWT from "jsonwebtoken";
import moment from 'moment';

export default {
  data: () => ({
    expand: true,
    taskDialog: false,
    taskDialogData: {
      Name: null
    },
    confirmDialog: {
      show: false,
      message: ""
    },
    AllocationForm: {
      CustomerID: null,
      CustomerVenueID: null,
      SystemUserID: null,
    },
    adhocDialog: false,
    locationDialog: false,
    location: null,
    hasLocationError: null,
    googleMapSrc: "",
    date: new Date().toISOString().substring(0, 10),
    currentMonth: new Date().getMonth(),
    pickerDate: null,
    latlon: null,
    address: "",
    UserTasks: [],
    events: [],
    customerItems: [],
    venueItems: [],
    selectedTask: null,
    photoUrl: null,
    showPhoto: false,
    userID: 0,
    role: 0,
  }),
  mounted() {
    let self = this;
    self.userID = localStorage.getItem("USER_ID");
    self.role = localStorage.getItem("Role");

    self.$nextTick(() => {
      this.GetUserTasks();
      this.GetCustomers();
    })

  },
  watch: {
    pickerDate(val) {
      var date = new Date(val);
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().substring(0, 10);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().substring(0, 10);
      let lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString();

      this.fetchAllocations(firstDay, lastDate);
    }
  },
  computed: {
    dayEvents() {
      return this.UserTasks.filter(el => el.AllocatedDate.split("T")[0] == this.date);
    }
  },
  methods: {
    fetchAllocations(start, end) {
      let self = this;

      self.$refs.Loader.show();
      self.$refs.Loader.setText("Fetching Data...");

      let sessionData = self.$store.getters.getUserSessionData;
      let tokenDecoded = JWT.decode(sessionData.AccessToken);
      let userID = tokenDecoded.USER_ID;

      self.get(`OpsManagerAssessmentAllocation/GetAllocationsByUser?userId=${userID}&start=${start}&end=${end}`).then(r => {
        if (r.data == null) {
          self.$refs.Loader.hide();

          return;
        }
        self.UserTasks = r.data;
        self.events = r.data.map(item => item.AllocatedDate.split("T")[0]);

        self.$refs.Loader.hide();
      });
    },
    GetUserTasks() {
      let self = this;
      let sessionData = self.$store.getters.getUserSessionData;
      let tokenDecoded = JWT.decode(sessionData.AccessToken);
      let userID = tokenDecoded.USER_ID;

      self.get(`MeetingTask/SystemUserID?systemUserID=${userID}`).then(r => {
        if (r.data == null) {
          return;
        }
        self.UserTasks = r.data;
      });
    },
    GetLocation() {
      let self = this;
      self.hasLocationError = false;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          self.showPosition,
          self.locationError
        );
      } else {
        self.location = "Geolocation is not supported by this browser.";
      }
    },
    GetCustomers() {
      let self = this;
      let url = `Customer`

      self.get(url)
        .then(response => {
          self.customerItems = response.data;
        })
        .catch(error => {
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(error.toString());
        });
    },
    GetCustomerVenues() {
      let self = this;

      self.$nextTick(() => {
        var customerID = self.AllocationForm.CustomerID.ID;
        self.get(`CustomerVenue/CustomerID?customerID=${customerID}`).then(
          r => {
            self.venueItems = r.data;
          })

      })
    },
    async showPosition(position) {
      let self = this;
      self.location =
        "Latitude: " +
        position.coords.latitude +
        ", Longitude: " +
        position.coords.longitude;

      self.latlon = position.coords.latitude + "," + position.coords.longitude;
      var res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${self.latlon}&key=AIzaSyCaCxMLn92kK8WC4iTaZNBE419qDj7d2S8`);

      var jsonRes = await res.json();

      console.log(jsonRes);

      if (jsonRes.status == "OK") {
        self.address = jsonRes.results[0].formatted_address;
      }

    },
    mapsSelector() {
      let self = this;
      if (
        /* if we're on iOS, open in Apple Maps */
        navigator.platform.indexOf(
          "iPhone"
        ) != -1 ||
        navigator.platform.indexOf("iPad") != -1 ||
        navigator.platform.indexOf("iPod") != -1
      )
        window.open(`maps://maps.google.com/maps?daddr=${self.latlon}&amp;ll=`);
      /* else use Google */
      else
        window.open(
          `https://maps.google.com/maps?daddr=${self.latlon}&amp;ll=`
        );
    },
    locationError(error) {
      let self = this;

      console.log("LOCATION ERROR", error);
      self.location = error.message;
      self.hasLocationError = true;
    },
    showInMap(pos) {
      let self = this;
      self.latlon = pos.coords.latitude + "," + pos.coords.longitude;
      var img_url = `https://maps.googleapis.com/maps/api/staticmap?center="${self.latlon
        }" &zoom=14&size=400x300&sensor=false&&markers=color:blue%7Clabel:%7C${self.latlon
        }&key=AIzaSyC5tXRKX6Wz8f2RrAzFeifrzkNB0EIYL-A`;
      self.googleMapSrc = img_url;
    },
    viewTask(task) {
      let self = this;

      console.log(task.AllocatedDate.split("T")[0], moment().format(`YYYY-MM-DD`));
      if (task.AllocatedDate.split("T")[0] != moment().format(`YYYY-MM-DD`)) {
        alert(`Task is not valid for today`)
        return;
      }

      if (task.CheckedIn && task.CheckedOut)
        return;

      self.selectedTask = task;
      self.confirmDialog.message = "Confirm";
      self.confirmDialog.show = true;
    },
    cancelLConfirm() {
      let self = this;

      self.selectedTask = null;
      self.confirmDialog.show = false;
      self.confirmDialog.message = "";
    },
    cancelAdHocVisit() {
      let self = this;

      self.selectedTask = null;
      self.adhocDialog = false;
      self.AllocationForm.CustomerID = null;
      self.AllocationForm.CustomerVenueID = null;
    },
    showLocationDialog() {
      this.GetLocation();

      this.locationDialog = true;
    },
    showAdhocDialog() {
      this.adhocDialog = true;
    },
    startAdhocVisit() {
      this.SubmitAllocation();
    },
    SubmitAllocation() {
      let self = this;

      let request = {
        AllocatedDate: new Date().toISOString(),
        CustomerID: self.AllocationForm.CustomerID.ID,
        CustomerVenueID: self.AllocationForm.CustomerVenueID.ID,
        SystemUserID: self.userID,
        IsAdHoc: true
      }

      self.$refs.Loader.show();
      self.$refs.Loader.setText("Creating Allocation");

      self.post(`OpsManagerAssessmentAllocation/Allocate`, request).then(r => {
        self.$refs.Loader.hide();
        self.selectedTask = r.data;
        self.adhocDialog = false;

        self.showLocationDialog()
      }).catch(err => {
        self.$refs.Loader.hide();
        console.log("ERROR", err.message, err.response);

        if (err.response != null) {
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(err.response.data.Message);
        }
      });
    },
    confirmLocation() {
      let self = this;

      self.$refs.Loader.show();
      self.$refs.Loader.setText("Confirming Location...");

      let id = this.selectedTask.ID;
      let lat = this.latlon.split(",")[0];
      let long = this.latlon.split(",")[1];

      self.get(`Location/ConfirmGeoLocation?allocationId=${id}&longitude=${long}&latitude=${lat}`).then(r => {
        self.$refs.Loader.hide();
        console.log(r)

        if (r.data) {
          if (r.data.Success) {
            self.$router.push(`/OpsManager/Tasks/${this.selectedTask.ID}/${this.selectedTask.CustomerVenueID}`)
          } else {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(r.data.Message);
          }
        }
      }).catch(err => {
        console.log("ERROR", err);
      });
    },
    completeTask() {
      let self = this;
      let id = self.taskDialogData.ID;
      self.post(`MeetingTask/CompleteTask?id=${id}`).then(r => {
        if (r.data) {
          self.GetUserTasks();
          self.taskDialog = false;
        }
      });
    },
    openFileDialog() {
      let self = this;
      self.$refs.fileInput.value = null;
      self.$refs.fileInput.click();
    },
    onImageChange(e) {
      let self = this;

      const files = e.target.files;
      let file = files[0];
      self.blobToDataUrl(file, url => {
        self.displayImage = url;
        // self.blobToArrayBuffer(file, result => {
        //   self.profile.image = Array.from(new Uint8Array(result));
        // })
      });
    },
    getColor(date) {
      var tasks = this.UserTasks.filter(x => x.AllocatedDate.split("T")[0] == date);

      return tasks.map(item => {
        if (item.Complete)
          return "green"
        if (!item.Complete)
          return "orange"
      })
    },
    blobToArrayBuffer(blob, callback) {
      var a = new FileReader();
      a.onload = function () {
        callback(a.result);
      };
      a.readAsArrayBuffer(blob);
    },
    blobToDataUrl(blob, callback) {
      var a = new FileReader();
      a.onload = function () {
        callback(a.result);
      };
      a.readAsDataURL(blob);
    },
    showImage(item) {
      let self = this;
      self.showPhoto = true;

      let address = self.$Config.ServerAddress;
      self.photoUrl = `${address}Photo/Stream/Meeting?id=${item.ID}`;
    },
  }
};
</script>

<style></style>